// Store GET query params in sesseiion storage

import { defaultQueryReq } from '.';

const key = 'activity_orders_query_params';

export const GetOrdersQuery = () => {
    const query = sessionStorage.getItem(key);
    return query ? JSON.parse(query) : defaultQueryReq;
};

export const SetOrdersQuery = (query) => {
    sessionStorage.setItem(key, JSON.stringify(query));
};
